import React from "react";
import { Box } from "@mui/material";
import Accordion from "../Accordion/Accordion";
import { essenceListSx } from "./essenceListSx";

const EssenceDrawer = ({ categories, subCategories, activeCategoryId, selectedSubCats, onEssenceChange, navigateToCategory }) => {
    return (
        <Box
            className="category-drawer"
            sx={{
                px: 2,
                ...essenceListSx,
                // Compact dropdowns: the shared accordion is sized for the product page.
                '& .accordion': { mb: 1 },
                '& .accordion-header': { py: '6px', px: '12px' },
                // Same keys as in essenceListSx, so spread them to keep the shared font.
                '& .accordion-header .title': { ...essenceListSx['& .accordion-header .title'], my: '6px' },
                '& .accordion-header .expand-sign': { ...essenceListSx['& .accordion-header .expand-sign'], fontSize: '16px' },
                '& .accordion-inner': { p: '4px 8px 8px' },
            }}
        >
            {categories?.map(category => (
                <Accordion
                    key={category.documentId || category.id}
                    title={category.title}
                    onTitleClick={() => navigateToCategory(category.documentId)}
                >
                    {/* sub-category schema has no relation to category, so every
                        essence of the current locale is listed (same as desktop) */}
                    <div className="essence-list">
                        {subCategories?.map((item) => {
                            // ids must be unique per category, otherwise the label
                            // toggles the checkbox of the first category with that essence
                            const inputId = `${category.documentId}-${item.documentId}`;
                            return (
                                <label className="inputItem" htmlFor={inputId} key={inputId}>
                                    <input
                                        type="checkbox"
                                        id={inputId}
                                        value={item.documentId}
                                        checked={activeCategoryId === category.documentId && selectedSubCats.includes(item.documentId)}
                                        onChange={(e) => onEssenceChange(e, category.documentId)}
                                    />
                                    <span>{item.title}</span>
                                </label>
                            );
                        })}
                    </div>
                </Accordion>
            ))}
        </Box>
    );
};

export default EssenceDrawer;
